import { Router } from "@angular/router";

import { Constantes } from '../../shared/constant/constantes';

declare const $: any;

export class UtilidadMenuEstadisticas {
    protected static utilidadMenuEstadisticas: UtilidadMenuEstadisticas;
    public constante: Constantes = new Constantes();

    constructor() { }


    static getInstance(): UtilidadMenuEstadisticas {
        if (!this.utilidadMenuEstadisticas) {
            this.utilidadMenuEstadisticas = new UtilidadMenuEstadisticas();
        }
        return this.utilidadMenuEstadisticas;
    }

    public selectOpcion(classBox: string, nameImg: string, nombreOpcion: string) {
        const img_div = document.getElementById('imgSelected' + nombreOpcion);
        const info_div = img_div!.getElementsByTagName('div')[0];
        const select_link = document.getElementsByClassName('linkSelected' + nombreOpcion)[0];
        select_link.id = nameImg;
        this.cambiaImagenFondo(nameImg, nombreOpcion);
        this.modificarEstilosByClass(classBox, 'mls_caja_titulo_selected', 'mls_caja_titulo');

        const idDescription = 'descripcion' + nombreOpcion;
        var delStyleDesc = 'descripcion';
        var newStyleDesc = 'descripcion_selected';
        if (classBox == 'mls_caja2') {
            delStyleDesc = 'descripcion2';
            newStyleDesc = 'descripcion2_selected';
        }
        this.modificarEstilosById(idDescription, delStyleDesc, newStyleDesc);

        info_div.style.setProperty('opacity', '1');
    }

    public notSelectOpcion(classBox: string, imgDefault: string, nombreOpcion: string) {
        const img_div = document.getElementById('imgSelected' + nombreOpcion);
        const info_div = img_div!.getElementsByTagName('div')[0];
        const idDescription = 'descripcion' + nombreOpcion;
        var delStyleDesc = 'descripcion';
        var newStyleDesc = 'descripcion_selected';
        if (classBox == 'mls_caja2') {
            delStyleDesc = 'descripcion2_selected';
            newStyleDesc = 'descripcion2';
        }
        this.cambiaImagenFondo(imgDefault, nombreOpcion);
        this.modificarEstilosById(idDescription, delStyleDesc, newStyleDesc);
        info_div.style.setProperty('opacity', '0');
    }

    public cambiaImagenFondo(nameImg: string, nombreOpcion: string) {
        const select_img = document.getElementById('imgSelected' + nombreOpcion);
        const select_descripcion = document.getElementById('descripcion' + nombreOpcion);
        var urlImg = this.constante.getUrlImg(nameImg);
        if (select_descripcion != null) {
            var idDescripcion = "desc_" + nameImg;
            var textoDescripcion = this.constante.OBJ_DESCRIPCION[idDescripcion];
            if (textoDescripcion == undefined || textoDescripcion == null) {
                textoDescripcion = '';
            }
            select_descripcion.innerHTML = textoDescripcion;
        }
        select_img!.style.backgroundImage = "url(" + urlImg + ")";
    }

    public modificarEstilosByClass(classElement: string, deleteCss: string, newCss: string) {
        const elementByClass = document.getElementsByClassName(classElement);
        for (let i = 0; i < elementByClass.length; i++) {
            if (elementByClass[i].classList.contains(deleteCss)) {
                elementByClass[i].classList.remove(deleteCss);
            }
            elementByClass[i].classList.add(newCss);
        }
    }

    public modificarEstilosById(idElement: string, deleteCss: string, newCss: string) {
        const elementById = document.getElementById(idElement);
        if (elementById!.classList.contains(deleteCss)) {
            elementById!.classList.remove(deleteCss);
        }
        elementById!.className = newCss;
    }

    public deslizarCuadro(elementFirst: string, elementSecond: string) {
        let element = '#' + elementFirst;
        $(element).slideToggle();
        element = '#' + elementSecond;
        $(element).slideUp();
    }

    public esNumero(value: any): boolean {
        try {
            if (isNaN(value)) {
                return false;
            } else {
                return true;
            }
        } catch {
            return false;
        }
    }

    public desplegarTabla(id: string) {
        const obj = document.getElementById('div_tabla_' + id);
        if (obj!.style.display == 'none') {
            obj!.style.display = 'block';
        } else {
            obj!.style.display = 'none';
        }
    }


    public removeHashFromUrl(url: string): string {
      return url.replace('/#', '');
    }
        
}
